import {isNotUndefined} from '@logistics-frontend/utils'
import {array, boolean, number, object, string} from 'yup'

export const OfferCalculate = object({
  route_points: array(
    object({
      lon: number().required(),
      lat: number().required(),
    }).required(),
  )
    .min(2)
    .required(),
  items: array(
    object({
      size: object()
        .optional()
        .default(undefined)
        .shape({
          length: number(),
          width: number(),
          height: number(),
        })
        .notRequired(),
      title: string().optional().notRequired(),
      weight: number().optional().default(undefined).notRequired(),
      quantity: number().required(),
      pickup_point: number().notRequired(),
      dropoff_point: number().notRequired(),
    }).notRequired(),
  ).notRequired(),
  requirements: object({
    taxi_class: array(string().required()).required(),
    cargo_type: string().notRequired(),
    cargo_loaders: number().notRequired(),
    cargo_options: array(string()).notRequired(),
    pro_courier: boolean().notRequired(),
    assign_robot: boolean().notRequired(),
    skip_door_to_door: boolean().notRequired(),
    due: string().notRequired(),
  }).required(),
  payment_info: object({
    type: string().required(),
    kind: string().required(),
    method_id: string().notRequired(),
    complements: array(
      object({
        id: string().notRequired(),
        type: string().required(),
      }).notRequired(),
    ).notRequired(),
  }).required(),
  same_day_data: object()
    .optional()
    .default(undefined)
    .shape({
      delivery_interval: object().optional().shape({
        from: string(),
        to: string(),
      }),
    }),
}).test('route-points-items-check', 'Route points must be one more than items', function ({route_points, items}) {
  const maxDropOffPointIndex = items ? Math.max(...items.map(item => item.dropoff_point).filter(isNotUndefined)) : 0
  return !!route_points?.[maxDropOffPointIndex]
})
